import { DataFromUrl, EditJob, goToNextPage, handleOtherResponseCode, Job, REDIRECT, SUCCESS_REPONSE_CODE, toastr, 
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, useRouter, CustomToastrAction } from  '@/imports-files/pages/clients/jobs/new';
import NumberFormat from 'react-number-format';

export async function getJobInitials(router, setApiError, session)
{
  if(session.role == "SubAdministrator"){
    setApiError({status: 403 })
  }
  else{
    const result = await new Job().getJobData();
    if(result.request.status == 200){
      return result.data;
    }
    else{
      setApiError(result.request)
    }
  }
}

export async function getJobWithTitleId(job_title_id)
{
  const result = await new Job().getJobDataByJobTitle(job_title_id);
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      return result.data;
    case RESOURCE_NOT_FOUND_REPONSE_CODE:
      console.log("Job Not found by title.")
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function handleFormSubmit(values, router, t, setPageName, queryClient, formik, fromKanban, gotoKanban, setDisabledSaveButton)
{

  setDisabledSaveButton(true)
  let result  =  {}
  const jobId =  new DataFromUrl().getJobId() || values.job.id;
  let idRegex =  new RegExp("[0-9]")
  values.job.draft = true
  values.job.really_draft = false
  if(idRegex.test(jobId))
  {  
    result = await new Job().updateJob(values, values.job.id);
  }
  else
  {
    result = await new Job().createJob(values);
  }
 
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    let queryPath = fromKanban ? "?from_kanban=true" : ""
    if(gotoKanban){
      if(fromKanban){
        router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', response.id)});
      }
      else{
        router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'Active' } });
      }
    }
    else
    router.push(REDIRECT.client.jobs.job_options.replace('$job_id', response.id)+queryPath);
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    let message = "";
    if(result.response.data.error.job?.hiring_manager_emails){
      message +=  `${result.response.data.error.job.hiring_manager_emails}`
    }
    if(result.response.data.error.job?.job_owner_emails){
      if(message.length > 0) { message += "</br>"}
      message += `${result.response.data.error.job.job_owner_emails}`
    }
    if(message.length > 0) { new CustomToastrAction().setNormalToastr(message, 'warning');
                              // toastr.warning(message);  }
                           }
    const job_error = result.response.data.error
    if(job_error.job.full_address){
      job_error.job["location_attributes"] = {}
      job_error.job.location_attributes["full_address"] = job_error.job.full_address
      delete job_error.job["full_address"]
    }
    delete job_error.job["hiring_manager_emails"]
    delete job_error.job["job_owner_emails"]
    formik.current.setStatus(job_error);
    formik.current.setErrors(job_error);
     setDisabledSaveButton(false)
    break;
  default: 
    handleOtherResponseCode(status_code, router);
     setDisabledSaveButton(false)
  }
}

export async function getJobTitles(name, router){
  const body                =   {name: name }
  const result              =   await new Job().getJobTitlesByName(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if (response.job_titles.length > 0) 
    {
      return response.job_titles
    }
    else {
      return [];
    }
    
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return []
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export async function getJobEditInitials(router, setApiError)
{
 
  const jobId         =   new DataFromUrl().getJobId();
  const job_result    =   await new EditJob().getJobInfo(jobId);
  var result          =   await new Job().getJobData();
  if(job_result.request.status == 200 && result.request.status == 200){
    const job           =   job_result.data.job || null;
    result              =   result.data;
    var data            =  {
                              props: {
                                        job,
                                        result
                                     }
                           }
    return data;
  }
  else{
    setApiError(job_result.request)
  }

}

export function NumberField({field, className, disabled, format, placeholder, style, formik}) {
  return <NumberFormat {...field} 
    thousandsGroupStyle="thousand"
    name={field.name}
    format={format}
    decimalSeparator="."
    displayType="input"
    type="text"
    className={className}
    style={style}
    formik={formik}
    disabled={disabled}
    placeholder={placeholder}
    thousandSeparator={true}
    allowNegative={false}
  />
}

export function getRequiredApprovedHash(total_count)
{
    let select_hash = [{label:'All', values: total_count}]
    for(let i=1; i<total_count; i++)
    {
        select_hash.push({label:`Any ${i}`, values: i})
    }
    return total_count == 0 ? [] : select_hash;
}

export function getValueHash(total_count, email_count, formRef)
{
    let hash;
    if(total_count == email_count)
    {
      hash = {label:'All', values: total_count};
    }
    else if(typeof total_count != 'undefined' && total_count != '')
    {  
      hash = {label:`Any ${total_count}`, values: total_count};
    }
    else    
    {
      hash = '';
    }

    if(formRef.current && hash && hash !='')
    {
      formRef.current.setFieldValue('job.approvers.required_approvers', hash.values);
      formRef.current.setFieldValue('job.required_approvers', hash.values);
    }
    return hash;
}


export function handleRequiredApproved(option, formik, event, setRequiredApprovers, setFlagForRender)
{
  formik.setFieldValue('job.approvers.required_approvers', option.values)
  formik.setFieldValue('job.required_approvers', option.values)
  formik.validateField('job.approvers.required_approvers');
 
  formik.values.job.approvers.required_approvers = option.values
  formik.values.job.required_approvers = option.values

  setRequiredApprovers(option)
  setFlagForRender(Math.random() * 10000);
}

export function showImportPreviousJob(router, values)
{
    var result = false;
    if(router.query.job_id && router.pathname.includes('/edit') && values.job.can_import)
    {
        result = true;
    }
    
    if(router.pathname.includes('/jobs/new'))
    {
      result = true;
    }
 
    return result;
}

export async function getDepartmentsList(name, router){
  const body                =   {name: name }
  const result              =   await new Job().getDepartmentsByName(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if (response.departments.length > 0)
    {
      return response.departments
    }
    else {
      return [];
    }

  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    return []
  default:
    handleOtherResponseCode(status_code, router);
  }
}

export function canGenerateDescription(formik, descriptionModal, setDescriptionModal,  router, setShowLoader, setIsOpen){
  const customToastrAction  =   new CustomToastrAction();
  let jobData = formik.values.job
  if(jobData.job_title_name && jobData.job_title_name.trim().length > 0){
    setShowLoader(true)
    const values = { job_title: jobData.job_title_name }
    if(descriptionModal.data.tone_of_voice) values.tone_of_voice = descriptionModal.data.tone_of_voice || ''
    if(descriptionModal.data.language) values.language = descriptionModal.data.language
    if(jobData.employment_type.length > 0) values.employment_type = jobData.employment_type
    if(jobData.contract_type.length > 0) values.contract_type = jobData.contract_type
    if(jobData.industry_id) values.industry_id = jobData.industry_id
    if(jobData.seniority_level_id) values.seniority_level_id = jobData.seniority_level_id
    generateDescription(values, formik, router, setShowLoader, setIsOpen)
  }
  else{
    customToastrAction.setNormalToastr("Please enter job title to generate the job description.", 'warning');
  }
}

export async function generateDescription(values, formik, router, setShowLoader, setIsOpen){
  const body                =   { generate_description : values}
  const result              =   await new Job().generateJobDescription(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction();
  setShowLoader(false)
  setIsOpen(false)
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    formik.setFieldValue('job.description', result.data.description)
    customToastrAction.setNormalToastr(result.data.success, 'success');
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    break;
  default:
    handleOtherResponseCode(status_code, router);
    break;
  }
}
